<template>
  <VanPopup
    :show="show"
    class="w-[80%] max-h-[90%] p-6 max-w-[440px]"
    rounded
    @update:show="emit('update:show', $event)"
  >
    <div
      v-for="(mode, idx) in userStore.isCNUser ? list : list.slice(0, -1)"
      :key="idx"
      class="mb-6"
    >
      <h1 class="text-base font-semibold">
        {{ $t(mode.title) }}
      </h1>
      <p class="mt-1.5 mb-2.5 text-xs">{{ $t(mode.content) }}</p>
      <ul class="flex gap-2.5">
        <li
          v-for="(item, idx) in mode.list"
          :key="idx"
          class="w-[72px] h-[72px] flex flex-col items-center justify-center gap-1.5 bg-primary rounded-lg cursor-pointer"
          @click="clickToGenerate(item.mode)"
        >
          <i :class="['iconfont text-[20px] leading-[20px]', item.icon]"></i>
          <span>{{ $t(item.text) }}</span>
        </li>
      </ul>
    </div>

    <div class="text-center mb-4">
      <button class="btn btn-sm" @click="emit('update:show', false)">
        {{ t("Buttons.close") }}
      </button>
    </div>
  </VanPopup>

  <CreateTraitPresetModal v-model:show="showCreateTraitModal" />
</template>
<script lang="ts" setup>
import { useGlobalUser } from "@/stores/globalUser";
import { useMateTrait } from "@/stores/mateTrait";
import { showConfirmDialog, showLoadingToast } from "vant";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";

const { t } = useI18n();

const router = useRouter();
const route = useRoute();
const userStore = useGlobalUser();
const traitStore = useMateTrait();
const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
});
const showCreateTraitModal = ref(false);

const emit = defineEmits({
  "update:show": (val: boolean) => undefined,
  generate: () => undefined,
});

// case Mixed = 1; // 混合模式
//     case SinglePerson = 2; // 单人图
//     case MultiplePersons = 3; // 多人图
//     case NoPerson = 4; // 无人图
//     case Redraw = 5; // 转绘
//     case ReplaceCharacter = 6; // 更换人物
//     case PresetFeature = 7; // 预设特征
//     case TextGenerateFeature = 8; // 文生特征
//     case ImageGenerateFeature = 9; // 图生特征

// t('xxx')不具备响应性，因此需要放在template context中用t渲染
// @see https://github.com/intlify/vue-i18n/issues/1396
const list = [
  {
    title: "painting.paintType.text.title",
    content: "painting.paintType.text.content",
    list: [
      {
        icon: "icon-profile",
        text: "painting.paintType.text.single",
        mode: 2,
      },
      {
        icon: "icon-muti-img",
        text: `painting.paintType.text.multi`,
        mode: 3,
      },
      // {
      //   icon: "icon-nobody",
      //   text: `painting.paintType.text.nobody`,
      //   mode: 4,
      // },
    ],
  },
  {
    title: "painting.paintType.img.title",
    content: "painting.paintType.img.content",
    list: [
      {
        icon: "icon-image",
        text: "painting.paintType.img.repaint",
        mode: 5,
      },
      {
        icon: "icon-user-edit",
        text: "painting.paintType.img.replace",
        mode: 6,
      },
      {
        icon: "icon-emoji",
        text: "painting.paintType.img.emoji",
        mode: 10,
      },
    ],
  },
  {
    title: "painting.paintType.mix.title",
    content: "painting.paintType.mix.content",
    list: [
      {
        icon: "icon-update",
        text: "painting.paintType.mix.name",
        mode: 1,
      },
    ],
  },
];
const clickToGenerate = async (mode: number) => {
  if (mode === 1) {
    if (route.name !== "imageGeneration")
      router.push({ name: "imageGeneration" });
  } else {
    if ([2, 3].includes(mode)) {
      if (traitStore.traitList.length === 0) {
        const loading = showLoadingToast({
          message: t("loading"),
          duration: 0,
        });
        await traitStore.getOrFetchTraitList();
        loading.close();

        if (traitStore.traitList.length === 0)
          return showConfirmDialog({
            title: t("painting.people.noFeatureInfo"),
            message: t("painting.people.noFeatureInfoDesc"),
            cancelButtonText: t("Buttons.cancel"),
            confirmButtonText: t("painting.people.create"),
          })
            .then(() => {
              showCreateTraitModal.value = true;
              emit("update:show", false);
            })
            .catch(() => {});
      }

      console.log(traitStore.traitList.length);
    }

    setTimeout(() => {
      router.push({
        name: "imagePaintWithMode",
        query: { mode },
      });
    });
    if (route.name === "imagePaintWithMode") {
      router.back();
    }
  }
  emit("update:show", false);
};
</script>
